var map = {
	"./2023/autumn/poster/day_report_fail.png": "9fa2",
	"./2023/summer/poster/day_report_fail.png": "d253",
	"./2024/autumn/poster/day_report_fail.png": "066f",
	"./2024/summer/poster/day_report_fail.png": "3b7c",
	"./2024/winter/poster/day_report_fail.png": "c6da",
	"./2025/spring/poster/day_report_fail.png": "273a",
	"./2025/summer/poster/day_report_fail.png": "73aa",
	"./2025/winter/poster/day_report_fail.png": "828d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7206";